import Newsletter from "../components/shared/newsletter";
import Configuration from "../components/configuration/configuration";
import ProductTranslationSimilar from "../components/product_translation_similar/product_translation_similar";

import mountReactComponents from "../src/render_components";

mountReactComponents({ Newsletter, Configuration, ProductTranslationSimilar });